var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');
var profileActions = require('../../../modules/profile/actions/profile');
var collectZipCodeMetaActions = require('../../../modules/meta/actions/collect-zip-code');

var CollectZipCodeModal = createReactClass({
    componentDidMount: function(){
        this.props.recordCollectZipCodeMeta('show', 'componentDidMount');
    },

    componentWillReceiveProps: function(nextProps){
        if(nextProps.profile.data.postalCode){
            this.onClose();
        }
    },

    componentWillUnmount: function(){
        this.props.clearPostalCodeError();
    },

    onClose: function() {
        this.props.hideModal();
    },

    saveZipCode: function(e){
        this.props.saveProfilePostalCode(this.refs.postalCode.value.trim(), this.props.token);
        this.props.recordCollectZipCodeMeta('click', e.currentTarget.innerText);
    },

    render: function() {
        var id = this.props.modal.props.id || 'collectZipCode';

        return (
            <Modal onClose={this.onClose} id={id}>
                <div className="text">
                    <p>Hey {this.props.profile.data.firstName}! Please enter your ZIP Code below.</p>
                    <p>Your location helps us find relevant clinical trials near you.</p>
                </div>
                <div className="actions">
                    <div className="postalCode-field-wrap">
                        <input type="text" name="postalCode" id="postalCode" ref="postalCode" placeholder="ZIP Code" required />
                        {Object.keys(this.props.profile.postalCodeError).length > 0 && (
                            <p className="error">{this.props.profile.postalCodeError}</p>
                        )}
                    </div>
                    <button className="button expanded primary" onClick={this.saveZipCode}>Save ZIP Code</button>
                    <button className="button expanded" onClick={this.onClose}>Add ZIP Code Later</button>
                </div>
            </Modal>
        );
    }

});

var mapStateToProps = function(state){
    return {
        token: state.auth.token,
        profile: state.profile
    };
}

var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, modalActions, profileActions, collectZipCodeMetaActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(CollectZipCodeModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/collectZipCodeModal.jsx